import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { CreateExternalLinkTo } from "../../../constants/linkTo";
import { useTranslation } from "react-i18next"
import { useAuth, useProfile } from "@brg/auth";

const useRussianGalleryTabs = () => {
  const { t, i18n: { language } } = useTranslation()

  const profile = useProfile()
  const auth = useAuth()

  const personalCollectionId = profile?.accountId || ''
  
  const forceLoginQuery = '?shouldForcedLogin=true&saveLoginUrl=true'
 
  return {
    [NAVBAR_TAB_NAMES.virtual_museum]: {
          active: false,
          content: t("nav.russian_gallery.virtual_museum"),
          level: 2,
          linkTo: CreateExternalLinkTo.russianGallllery('/old/catalog/art_of_slavs?card=6dab49ee094941fd9fd59fed9f0f1357'),
          target: '_blank',
        },
    [NAVBAR_TAB_NAMES.library]: {
          active: true,
          content: t("nav.russian_gallery.library"),
          level: 2,
          dsiabled: true,
          action: (e: any) => {
            e.preventDefault()
            e.stopPropagation()
            return
          },
          linkTo: `${process.env.REACT_APP_URL_BOOKS_GALLLLERY}/teams/russiangallllery`,
          target: '_blank',
        },
    [NAVBAR_TAB_NAMES.my_collection]: {
          active: false,
          content: t("nav.russian_gallery.my_collection"),
          action: (e: any) => {
            e.preventDefault()
            e.stopPropagation()
            if (!profile) {
              auth.login()
              return
            }
          window.open(CreateExternalLinkTo.russianGallllery(`/collection/${personalCollectionId}${forceLoginQuery}`), '_blank')
          },
          level: 2,
          linkTo: CreateExternalLinkTo.russianGallllery(`/collection/${personalCollectionId}${forceLoginQuery}`),
        },
    [NAVBAR_TAB_NAMES.ru_gal_timeline]: {
          active: false,
          content: t("nav.russian_gallery.timeline"),
          level: 2,
          linkTo: CreateExternalLinkTo.russianGallllery('/arthistory'),
          target: '_blank',
        },
    [NAVBAR_TAB_NAMES.ru_gal_tags]: {
          active: false,
          content: t("nav.russian_gallery.tags"),
          level: 2,
          linkTo: CreateExternalLinkTo.russianGallllery('/tags'),
          target: '_blank',
        },
    [NAVBAR_TAB_NAMES.ru_gal_shop]: {
          active: false,
          content: t("nav.russian_gallery.ru_gal_shop"),
          level: 2,
          linkTo: `${process.env.REACT_APP_URL_SHOP_MEDIIIA}/art?page=1`,
        },
  }
}

export default useRussianGalleryTabs;import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { CreateExternalLinkTo } from "../../../constants/linkTo";
import { useTranslation } from "react-i18next"
import { useAuth, useProfile } from "@brg/auth";

const useRussianGalleryTabs = () => {
  const { t, i18n: { language } } = useTranslation()

  const profile = useProfile()
  const auth = useAuth()

  const personalCollectionId = profile?.accountId || ''
  
  const forceLoginQuery = '?shouldForcedLogin=true&saveLoginUrl=true'
 
  return {
    [NAVBAR_TAB_NAMES.virtual_museum]: {
          active: false,
          content: t("nav.russian_gallery.virtual_museum"),
          level: 2,
          linkTo: CreateExternalLinkTo.russianGallllery('/old/catalog/art_of_slavs?card=6dab49ee094941fd9fd59fed9f0f1357'),
          target: '_blank',
        },
    [NAVBAR_TAB_NAMES.library]: {
          active: true,
          content: t("nav.russian_gallery.library"),
          level: 2,
          dsiabled: true,
          action: (e: any) => {
            e.preventDefault()
            e.stopPropagation()
            return
          },
          linkTo: `${process.env.REACT_APP_URL_BOOKS_GALLLLERY}/teams/russiangallllery`,
          target: '_blank',
        },
    [NAVBAR_TAB_NAMES.my_collection]: {
          active: false,
          content: t("nav.russian_gallery.my_collection"),
          action: (e: any) => {
            e.preventDefault()
            e.stopPropagation()
            if (!profile) {
              auth.login()
              return
            }
          window.open(CreateExternalLinkTo.russianGallllery(`/collection/${personalCollectionId}${forceLoginQuery}`), '_blank')
          },
          level: 2,
          linkTo: CreateExternalLinkTo.russianGallllery(`/collection/${personalCollectionId}${forceLoginQuery}`),
        },
    [NAVBAR_TAB_NAMES.ru_gal_timeline]: {
          active: false,
          content: t("nav.russian_gallery.timeline"),
          level: 2,
          linkTo: CreateExternalLinkTo.russianGallllery('/arthistory'),
          target: '_blank',
        },
    [NAVBAR_TAB_NAMES.ru_gal_tags]: {
          active: false,
          content: t("nav.russian_gallery.tags"),
          level: 2,
          linkTo: CreateExternalLinkTo.russianGallllery('/tags'),
          target: '_blank',
        },
    [NAVBAR_TAB_NAMES.ru_gal_shop]: {
          active: false,
          content: t("nav.russian_gallery.ru_gal_shop"),
          level: 2,
          linkTo: `${process.env.REACT_APP_URL_SHOP_MEDIIIA}/art?page=1`,
        },
  }
}

export default useRussianGalleryTabs;